module.exports = __webpack_public_path__ + "static/media/masonry_5.15614f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/masonry_5.jpg
// module id = 1131
// module chunks = 0